"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _IconArrowDownCircleOutline = _interopRequireDefault(require("./IconArrowDownCircleOutline"));
var IconArrowLeftCircleOutline = /*#__PURE__*/(0, _styledComponents.default)(_IconArrowDownCircleOutline.default).withConfig({
  displayName: "IconArrowLeftCircleOutline",
  componentId: "c11n-8-107-0__sc-mk3kt1-0"
})(["transform:rotate(90deg);"]);
var _default = IconArrowLeftCircleOutline;
exports.default = _default;